import React from 'react';
import { StandaloneLayout as StandardSurface } from '@/chat/ui/index.js';
import { CHAT_CONTENT_MAX_WIDTH } from '../../config/constants.js';
import { useLocale } from '../../locale/provider';
import { resolveChatBranding } from '../../config/resolveBranding.js';
import DevToolbarShell from './components/DevToolbarShell.jsx';

export default function StandaloneLayout({
  activeSession,
  activeWorkspaceTab,
  canvasAvailable = false,
  canvasDevDiagnostics = {},
  devToolbarConfig = {},
  initialInstanceProfile,
  projectSlot,
  showCanvasPanel,
  themeTokens,
  viewModel,
  ...surfaceProps
}) {
  const instanceProfile = viewModel?.session?.instanceProfile || initialInstanceProfile;
  const labels = useLocale();
  const branding = React.useMemo(() => resolveChatBranding({
    defaultUILabels: labels,
    instanceProfile,
  }), [instanceProfile, labels]);
  const standaloneSurface = (
    <StandardSurface
      {...surfaceProps}
      {...branding}
      activeSession={activeSession}
      activeWorkspaceTab={activeWorkspaceTab}
      canvasAvailable={canvasAvailable}
      contentMaxWidth={CHAT_CONTENT_MAX_WIDTH}
      fillContainer={Boolean(devToolbarConfig.enabled)}
      projectSlot={projectSlot}
      showCanvasPanel={showCanvasPanel}
      themeTokens={themeTokens}
      viewModel={viewModel}
    />
  );

  return (
    <DevToolbarShell
      activeSession={activeSession}
      activeWorkspaceTab={activeWorkspaceTab}
      canvasAvailable={canvasAvailable}
      canvasDiagnostics={canvasDevDiagnostics}
      config={devToolbarConfig}
      projectSlot={projectSlot}
      showCanvasPanel={showCanvasPanel}
      surfaceNode={standaloneSurface}
      themeTokens={themeTokens}
      viewModel={viewModel}
    />
  );
}
